import { FlexContentRowComponent } from "./FlexContentRowComponent";
import { MsoTable } from "./MsoTable";

export class FlexTableRowItem {
    private _isVisible: boolean = true;

    public get isVisible(): boolean {
        return this._isVisible;
    }

    constructor(private table: MsoTable, public model: any, public row: FlexContentRowComponent) {
    }

    public get modelId(): string {
        return this.model[this.table.props.idField];
    }

    public show(): void {
        this._isVisible = true;
        if (this.row) {
            this.row.show();
        }
    }

    public hide(): void {
        this._isVisible = false;
        if (this.row) {
            this.row.hide();
        }
    }

}